import { render, staticRenderFns } from "./OtpUsercomponent.vue?vue&type=template&id=da753508&scoped=true"
import script from "./OtpUsercomponent.vue?vue&type=script&lang=js"
export * from "./OtpUsercomponent.vue?vue&type=script&lang=js"
import style0 from "./OtpUsercomponent.vue?vue&type=style&index=0&id=da753508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da753508",
  null
  
)

export default component.exports